import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

// libraries
import * as networkSelectors from '@makemydeal/dr-dash-store/selectors/networkSelectors';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';

// components
import { Box } from '@interstate/components/Box';
import { Alert } from '@interstate/components/Alert';
import { Action } from '@interstate/components/Action';

const ConnectionStatusBanner = () => {
    const wsConnectionFailed = useSelector(networkSelectors.getWsConnectionFailed);

    useEffect(() => {
        if (wsConnectionFailed) {
            logNewRelicPageAction('MV:WebSocket', {
                type: 'userNotification',
                status: 'displayed'
            });
        }
    }, [wsConnectionFailed]);

    const handleRefreshPage = () => {
        logNewRelicPageAction('MV:WebSocket', {
            type: 'userNotification',
            status: 'reloaded'
        });
        window.location.reload();
    };

    if (!wsConnectionFailed) {
        return null;
    }

    return (
        <Box sx={{ padding: '1.2rem 1rem', maxWidth: '1920px', margin: 'auto' }}>
            <Alert data-testid="ws-connection-failed-banner" type="caution">
                Deal update notifications have been suspended by the browser. Please{' '}
                <Action data-testid="ws-connection-refresh-action" size="sm" onClick={handleRefreshPage}>
                    refresh
                </Action>{' '}
                to re-establish your connection.
            </Alert>
        </Box>
    );
};

export default ConnectionStatusBanner;
